import styles from "./ActionButton.module.scss";
import { classNames } from "primereact/utils";
import { Icon, IconType } from "../../../icons/Icon";

interface IIconButtonProps {
  iconType: IconType;
  iconHeight?: string;
  iconWidth?: string;
  disabled?: boolean;
  onClick?: () => void;
}

export const ActionButton = ({
  iconType,
  iconHeight,
  iconWidth,
  disabled,
  onClick = () => {},
}: IIconButtonProps) => {
  const iconColor = disabled ? "rgba(255, 255, 255, 0.3)" : "rgba(255, 255, 255, 0.85)";

  const icon = (
    <Icon
      type={iconType}
      height={iconHeight ?? "70%"}
      width={iconWidth ?? "100%"}
      color={iconColor}
    />
  );

  if (disabled) {
    onClick = () => {};
  }
  return (
    <div
      className={classNames(styles.root, {
        [styles.root_disabled]: disabled,
      })}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      {icon}
    </div>
  );
};
